import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

/**
 *  <ShowCommentDialog
 *    comment
 *    onClose=()
 *  />
 */

class ShowCommentDialog extends Component {

  state = {
		amount: "",
    comment: "",
	}

  componentDidMount() {
		this.setState({
			amount: this.props.amount ? this.props.amount : 0,
      comment: this.props.comment ? this.props.comment : "",
		})
	}

  render() {

    return <Dialog
      open = {true}
      scroll = "body"
    >

      <DialogTitle>Комментарий</DialogTitle>

      <DialogContent style = {{display: "flex", flexDirection: "column"}}>

        <Typography
          style={{whiteSpace: 'pre'}}
        >
          {this.props.comment}
        </Typography>

      </DialogContent>

      <DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onClose === "function") {
							this.props.onClose()
						}
					}}
				>Закрыть</Button>

			</DialogActions>

    </Dialog>
  }

}

export default ShowCommentDialog
